import { render, staticRenderFns } from "./PurchaseHistory.vue?vue&type=template&id=d659a654&"
import script from "./PurchaseHistory.vue?vue&type=script&lang=js&"
export * from "./PurchaseHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports